import React, { useState } from "react";
import Menu from "../../components/Menu";
import { useNavigate } from "react-router-dom";
import api from '../../api'
import Swal from 'sweetalert2'

import InputCPF from "../../components/InputCPF";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputDate from "../../components/InputDate";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";

import FooterAdd from "../../components/FooterAdd";
function CustomersAdd() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({
        name: false,
        cpf: false,
        email: false,
        phoneMobile: false,
        birth: false,
    })

    const [name, setName] = useState("")
    const [cpf, setCpf] = useState("")

    const [birth, setBirth] = useState("")
    const [email, setEmail] = useState("")
    const [phoneMobile, setPhoneMobile] = useState("")

    const [isDependent, setIsDependent] = useState(null)

    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            cpf: !Validations.CPFValid(cpf),
            email: email.replaceAll(' ', '') === '' ? false : !Validations.emailValid(email),
            phoneMobile: phoneMobile.replaceAll(' ', '') === '' ? false : !Validations.PhoneMobile(phoneMobile),
            birth: Validations.DateDDMMAAAAInvalid(birth),
            tipo: isDependent === null ? true : false
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (validations) {


            var data = {
                cpf : cpf.replaceAll(".", "").replaceAll("-", ""),
                name : name,
                birth : birth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3$2$1'),
                recovery_email: email.replaceAll(" ", ""),
                mobile : phoneMobile.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''),
                dependent: isDependent
            }

            setLoading(true)
            api.post("/api/customers", data).then((response) => {
                Swal.fire({
                    title: "Paciente cadastrado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })
                setTimeout(() => {
                    navigate("/customers/" )
                }, 2000);
            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Paciente não cadastrado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',
                })
            }).finally(() => {
                setLoading(false)
            })
        }

    }
    const screenTela =
        <>
            {loading && <LoadingBlock />}
            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Paciente</h1>
                    <div className="row">
                        <h4>Dados Básicos</h4>
                        <div className="col-12 col-sm-6 col-lg-6 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Email</label>
                                <input className="form-control" value={email} onChange={value => setEmail(value.target.value)} type="text" name="email" placeholder="Email" />
                                {error.email && <span className="error" >Campo Inválido</span>}

                            </div>
                            <div className="col-12">
                                <label className="form-label-input">CPF*</label>
                                <InputCPF value={cpf} onChange={setCpf} />
                                {error.cpf && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-6 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Data de Nascimento*</label>
                                <InputDate value={birth} onChange={setBirth} />
                                {error.birth && <span className="error" >Campo Inválido</span>}

                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Celular</label>
                                <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
                                {error.phoneMobile && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Tipo*</label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setIsDependent(false)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value={isDependent === null ? false : isDependent} />
                                        <label className="form-check-label" htmlFor="inlineRadio1">Próprio</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setIsDependent(true)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value={isDependent === null ? false : isDependent} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Dependente</label>
                                    </div>
                                </div>

                                {error.tipo && <span className="error" >Campo Inválido</span>}
                            </div>

                        </div>
                    </div>
                </div>
                <FooterAdd />
            </form>
        </>

    return (
        <Menu screen={screenTela} />
    )
}

export default CustomersAdd;